import {
  OnboardingLayoutContainer,
  OnboardingLayoutContent,
  OnboardingLayoutImage,
  TalentLogo,
} from "./index.styled";

const OnboardingLayout: React.FC = ({ children }) => {
  return (
    <OnboardingLayoutContainer>
      <OnboardingLayoutImage>
        <TalentLogo src="https://talentdio.s3.sa-east-1.amazonaws.com/assets/img/talent-match-onboarding.svg" />
      </OnboardingLayoutImage>

      <OnboardingLayoutContent>{children}</OnboardingLayoutContent>
    </OnboardingLayoutContainer>
  );
};

export default OnboardingLayout;
